<div id="productContainer" [ngClass]="config.isCxOne ? 'bg-white' : ''">
	<div *ngIf="config.isCxOne" class="row p-3 d-flex justify-content-between align-items-end">
		<div class="col">
			<span class="font-size-20 font-weight-600 color-black line-height-27" cvLocalizedText
				langSection="MarketPlace_Management" langKey="All_Products">All Products</span>
		</div>
		<div id="cxone-sort-by" class="col-lg-8 col-md-12 col-sm-12">
			<div class="d-lg-flex d-md-flex justify-content-end align-items-center">
				<span class="color-gray font-size-13 font-weight-600 line-height-18 pr-2" cvLocalizedText
					langSection="MarketPlace_Management" langKey="Sort_By_Colon">Sort
					by:</span>
				<sol-dropdown id="sort-by-dropdown" [placeholder]="''" class="w-30"
					[(ngModel)]="SortType" [options]="sortOptionsCXOne" [optionsLabel]="'name'" [optionsValue]="'value'"
					[required]="false" [searchEnabled]="false" [showFooter]="false" (ngModelChange)="updateProductsByRow();scrollToTop()">
				</sol-dropdown>
			</div>
		</div>
	</div>

	<div *ngIf="!config.isCxOne" class="row mt-3">
		<div class="col-12">
			<span cvLocalizedText clas="font-size-12" langSection="MarketPlace_Management" langKey="Sort_By_Colon">Sort
				By:</span>
			<select class="form-control w-25" [(ngModel)]="SortType" (ngModelChange)="updateProductsByRow()">
				<option *ngFor="let option of sortOptions" [ngValue]="option.value">{{option.name}}</option>
			</select>
		</div>
		<div class="col-12">
			<p></p>
		</div>
	</div>

	<div *ngIf="!config.isCxOne" [ngClass]="{'filterOpen': pspes.filterOpen}">
		<cdk-virtual-scroll-viewport [itemSize]="399" [minBufferPx]="798" [maxBufferPx]="1900" style="max-height: calc(100vh - 282px); height: 100vh;"
		[style]="pspes.filterOpen ? 'max-height: calc(100vh - 330px); height: 100vh;' : ''">
			<div class="row product-row" *cdkVirtualFor="let productRow of productsByRow">
				<div class="col-3" *ngFor="let product of productRow">
					<cv-point-store-product-landing-card-cv [product]="product"
															(editPointStoreProduct)="EditPointStoreProduct($event)"
															(copyPointStoreProduct)="CopyPointStoreProduct($event)"
															(removePointStoreProduct)="RemovePointStoreProduct($event)">
					</cv-point-store-product-landing-card-cv>
				</div>
			</div>
		</cdk-virtual-scroll-viewport>
	</div>

	<div *ngIf="config.isCxOne" class="px-2" cdkVirtualScrollingElement [ngClass]="{
			'product-container-custom-cxone': !pspes.filterOpen,
			'product-container-without-filters': pspes.filterOpen,
			'd-flex justify-content-center align-items-center bg-light-blue-2': productsByRow.length <= 0
		}">
		<div [ngClass]="{'filterOpen': pspes.filterOpen}">
			<ng-container [ngSwitch]="displayState()">
				<ng-container *ngSwitchCase="'no-state'">
					<cdk-virtual-scroll-viewport [itemSize]="326" [minBufferPx]="652" [maxBufferPx]="3260">
						<div class="d-flex flex-wrap" *cdkVirtualFor="let productRow of productsByRow">
							<div class="col-12 col-md-6 col-xl-3 p-2" [ngClass]="rowClass" *ngFor="let product of productRow">
								<cv-point-store-product-landing-card *ngIf="product" [product]="product"
									(editPointStoreProduct)="EditPointStoreProductCxone($event)"
									(copyPointStoreProduct)="CopyPointStoreProductCxone($event)"
									(removePointStoreProduct)="RemovePointStoreProduct($event)"
									(popoverElementEvent)="checkActivePopover($event)">
								</cv-point-store-product-landing-card>
							</div>
						</div>
					</cdk-virtual-scroll-viewport>
				</ng-container>
				<ng-container *ngSwitchCase="'empty-state'">
					<div id="product-container-empty-state" class="d-flex justify-content-center align-items-center">
						<div class="d-flex flex-column align-items-center">
							<svg class="">
								<use href="../App_Themes/Cxone/icons/empty-state.svg#empty-state"></use>
							</svg>
							<span class="font-size-16 line-height-22 font-weight-400 color-gray" cvLocalizedText
								langSection="MarketPlace_Management" langKey="Marketplace_Management_Empty_State_Text">
								No products added yet
							</span>
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'no-results-state'">
					<div id="product-container-no-results-state"
						class="d-flex justify-content-center align-items-center">
						<div class="d-flex flex-column align-items-center">
							<svg class="">
								<use href="../App_Themes/CXone/icons/no-results.svg#no-results"></use>
							</svg>
							<span class="font-size-16 line-height-22 font-weight-400 color-gray" cvLocalizedText
								langSection="MarketPlace_Management" langKey="No_Results_Found">
								No results found
							</span>
						</div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</div>
</div>